import React from 'react';

export default function Stepper ({ currentStep }) {
	const steps = [1, 2, 3, 4];

	return (
		<div className={`stepper stepper--${currentStep}`}>
			{steps.map((value, index) => {
				return (
					<div className={`stepper__step${(currentStep - 1) === index ? " stepper__step--active" : ''}`} key={index}>
						<span>{value}</span>
					</div>
				)
			})}
		</div>
	)
}
